module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Text/Font-0aaedce1752ee5c13b9577564e4c5336.svg";